/*
@file-overview

- This service was brougth over from AEM wcax-commons repo

- Contains the methods used for handling actions for adding/Updating/Removing products from /cart

*/
import { Inject, Injectable, NgZone } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Subject, Subscription, first } from 'rxjs';
import { CommonService } from './common.service';
import { AemService } from './aem.service';
import { UserInfoService } from './user-info.service';
import { CartV2Service } from './cart-v2.service';

import { IConfigObj } from '../models/data.model';

// jQuery
declare let $: any;

@Injectable()
export class CartService {

    // this variable will be used when local storage is disabled
    private _abCart = '';

    public objRefreshInterval;
    private _eventDispatched: boolean = false;
    public configObj: IConfigObj;
    public rightDrawerEvent = new Subject<any>();
    public $rightDrawerEvent = this.rightDrawerEvent.asObservable();
    public isGuestAddToCart;
    public isGuestAddToCartTestValue = 'a';
    public isGuestAddToCartABSubscription: Subscription;

    public constructor(
        @Inject('configObj') private configObjFromModule: any,
        private _http: HttpClient,
        private _commonService: CommonService,
        private _aemService: AemService,
        private _userInfoService: UserInfoService,
        private _cartV2Service: CartV2Service,
        zone: NgZone
    ) {
        window[ 'cartServiceRefAL' ] = {
            zone: zone,
            service: this,
        };
        this._commonService._userInfoRefresh.subscribe(data => {
            if (data === 'initFunc') {
                this.configObj = this.configObjFromModule ? this.configObjFromModule : {};
                const isB2BSite = this._userInfoService.getSiteType() === 'B';
                this.configObj.programType = isB2BSite ? '1P_B2B' : this.configObj?.programType;
                this._init();
            }
        });

    }


    private _init(){

       this._aemService.getStoreStatus();
       const objCart = this._get();


       this.isGuestAddToCartABSubscription = this._commonService.isABFlagDisabledEvent$.pipe(first(event => event.flagName === 'isGuestAddToCartDisabled')).subscribe((event)=>{
            this.isGuestAddToCart = event.testValue !== 'a' && !this._userInfoService.isAuthorized() && (!this.configObj.programType || this.configObj.programType === 'abs');
            this.isGuestAddToCartTestValue = event.testValue;
        })
       this._commonService.listenToABXTestingFlag('abACIP295974', 'isGuestAddToCartDisabled', 'ACIP295974',300);
       if (this._aemService.isLSCompatible() && this._lsHasValidErumsData(objCart) && 
            !(this._userInfoService.isAuthorized() && objCart['guestCartId'])) {
            // added for slice 3, checks 2 conditions :
            // 1. If on slice 1 banner and on SHOP side , 2. If on slice 3 banner and preference is not j4u
            if (this._userInfoService.getPreference() !== 'J4U') {
                if (this._userInfoService.isAuthorized() && !this._commonService.checkPendingOrder()
                && (!this.configObj?.appName || this.configObj?.appName !== 'dnf') )
        {
                    this._aemService.checkReserveTime();
                }
                this._commonService.checkPendingOrderAlert();
            }
            // trigger cartObjSource observer and loadCartPrice only if preference not J4U
            if (this._userInfoService.getPreference().toLowerCase() !== 'j4u') {
                this._commonService._cartObjSource.next(objCart);
                this._loadCartPrice();
            }

        } else {
            // added for slice 3, checks 2 conditions :
            // 1. If on slice 1 banner and on SHOP side , 2. If on slice 3 banner and preference is not j4u
            if (this._userInfoService.getPreference() !== 'J4U' ) {
                if (this._userInfoService.isAuthorized() && !this._commonService.checkPendingOrder()
                        && (!this.configObj?.appName || this.configObj?.appName !== 'dnf') )
                {
                    this._aemService.checkReserveTime();
                }
                this._commonService.checkPendingOrderAlert();
            }
            if (!this._commonService.checkPendingOrder()) {
                this._loadERUMSRemoteCart();
            }
        }

       if (this.objRefreshInterval) {
            clearInterval(this.objRefreshInterval);
        }

       this.objRefreshInterval = setInterval(() => {
            console.log('CART - INIIATING THE CART REFRESH');

            if (
                this._aemService.checkAuthorizedCookie()
                && this._aemService.isTokenActive()
                && this._aemService.authorize()
                && this._aemService.isLSCompatible()
                && this._userInfoService.getPreference() !== 'J4U'
            ) {
                console.log('CART - REFRESH CART');
                this.refreshCart();

            } else {
                console.log('CART - TIMER IS NOT REQUIRED');
                clearInterval(this.objRefreshInterval);
            }
        }, 900000);

    }

    public _loadRemoteCart() {

        if (this._aemService.authorize() && this._aemService.checkAuthorizedCookie()) {
            let strRequest = `?rand=${(Math.floor((Math.random() * 1000000)))}`;

            const orderNumber = this._aemService.getOrderNumberCookie();
            strRequest += (orderNumber !== '' && orderNumber != null) ? `&id=${orderNumber}` : '';
            const objHttp = this._http.get<any[]>(`${this._aemService.getMiniCartPath()}${strRequest}`);

            console.log('CART ANGULAR: INITIATED');

            objHttp.subscribe((objResponse: any) => {
                 if (!objResponse['ack']) {

                    const cartPrice = !this._commonService.isEmpty(objResponse['cartSummary'].cost)
                        ? 0.00
                        : objResponse['cartSummary'].cost;

                    const cartQty = !this._commonService.isEmpty(objResponse['cartSummary'].itemsCount)
                        ? 0
                        : objResponse['cartSummary'].itemsCount;

                    const objCart = {
                        cartItems: objResponse['cartItems'],
                        branchId: this._userInfoService.getShopStoreId(),
                        channel: this._userInfoService.getUserChannel(),
                        orderNumber: orderNumber,
                        erumsStore: false,
                        isWYSIWYGEnabled: objResponse['isWYSIWYGEnabled'],
                        cartPrice,
                        cartQty
                    };

                    if (objResponse.hasOwnProperty('isMTOOrder')) {
                        objCart['isMTOOrder'] = objResponse['isMTOOrder'];

                        if (objCart['isMTOOrder']) {
                            objCart['mtoMaxPrepTime'] = objResponse['mtoMaxPrepTime'];
                        }
                    }

                    console.log('CART ANGULAR: RESPONSE RECEIVED', objResponse['cartItems']);
                    this._set(objCart);
                    this._loadCartPrice();

                 }
            });
        }
    }

    /**
     * Method to trigger Cart get API
     * **/

    public _loadERUMSRemoteCart() {
        this.processGetCartV2();
    }

    /**
     * Method calls V2 of cart API using cart v2 service
     * on Success calls set method to ypdate cart LS with updated response
     * on Failure calls set method to updated cart LS with empty obj
     * set method will trigger cart observable to update quantity steppers
     * **/
    private processGetCartV2() {
        if(this.isGuestAddToCartTestValue === 'a' && this._get()['guestCartId']) {
            localStorage.removeItem('abCart');
        }
        if (this._aemService.authorize() || (this.isGuestAddToCart && this._get()['guestCartId']) ) {
            const custId = this._userInfoService.getCustomerId();
            if (custId || this.isGuestAddToCart) {
                const dataObs = this._cartV2Service.getCartV2(custId, this.configObj, this.isGuestAddToCart);
                this.processObsResponse(dataObs);
            }
        }
    }

    /**
     * Method which checks the user channel and return the intent preference parameter accordingly
     * @return {​string}​
     */
    public getIntendPreferenceParam(): string {

        const userChannelChoice = this._userInfoService.getUserChannel();
        let intentPreferenceParam = '';

        switch (userChannelChoice) {

            case 'pickup':
                intentPreferenceParam = '&serviceType=DUG';
                break;

            case 'delivery':
                const deliveryType = this._userInfoService.getUnattendedDeliveryIsEnabled() === true ? 'Unattended' : 'Attended';
                intentPreferenceParam = `&serviceType=Delivery&deliveryType=${deliveryType}`;
                break;

            case 'instore':
                intentPreferenceParam = '&serviceType=inStore';
                break;

            default:
                break;
        }

        return intentPreferenceParam;
    }

    public _set(objCart: any) {

        objCart['updatedTime'] = JSON.stringify(new Date());

        const objCartJSONstr = JSON.stringify(objCart);

        if (this._aemService.isLSCompatible()) {
            localStorage.setItem('abCart', objCartJSONstr);
            if ( !this._eventDispatched ) {
                const cartSavedToLS = new Event('cartSavedToLS');
                document.dispatchEvent(cartSavedToLS);
                this._eventDispatched = true;
            }
            if ((window.location.href).includes('erums/store/prebook') || (window.location.href).includes('erums/cart/dnf')
                || (window.location.href).includes('/product')){
                const cartUpdated = new CustomEvent('cartUpdated', {detail: objCart});
                document.dispatchEvent(cartUpdated);
            }
        } else {
            this._abCart = objCartJSONstr;
        }

        // trigger cartObjSource observer and loadCartPrice only if preference not J4U
        if (this._userInfoService.getPreference().toLowerCase() !== 'j4u') {
            this._commonService._cartObjSource.next(objCart);
            this._loadCartPrice();

            if((window.location.href).includes('view=instantCart')) {
                this._commonService._updateBiaAddAllBtn.next(true);
            }
        }
    }

    public _get(serviceType?) {

        let objCart = {};
        let strCart = '';

        if ( (serviceType??this._userInfoService.getPreference().toLowerCase()) !== 'j4u') {

            if (this._aemService.isLSCompatible()) {
                strCart = localStorage.getItem('abCart');
            } else {
                strCart = this._abCart;
            }

            try {
                if (strCart) {
                    try {
                        objCart = JSON.parse(strCart);
                    } catch (e) {
                        objCart = {};
                    }
                }

            } catch (e) {
                console.error('ERROR: COUPON - GETTING FROM LOCAL STORAGE');
                console.error(e);
            }
        }

        return objCart;
    }

    public _lsValidErumsData(objCart: any) {

        let response = false;

        if (!this._commonService.isEmpty(objCart)) {
            const isGuestAddToCart = !this._aemService.getFeatureFlagByNameDisable('isGuestAddToCartDisabled') && !this._userInfoService.isAuthorized() && (!this.configObj.programType || this.configObj.programType === 'abs') 

            if(this._commonService.checkPendingOrder()) {
                response = objCart['branchId'] === this._aemService.getOrderStoredIdCookie();
                response = objCart['orderNumber'] === this._aemService.getOrderNumberCookie();
            } else {
                response = objCart['branchId'] === this._userInfoService.getShopStoreId();
                response = objCart['channel'] === this._userInfoService.getUserChannel();
            }

            if (response && !this._commonService.checkPendingOrder()) {

                if (objCart['updatedTime'] !== undefined) {
                    const updatedTime = Date.parse(JSON.parse(objCart['updatedTime']));
                    const currentTime = Date.parse(JSON.parse(JSON.stringify(new Date())));
                    const timeDiff = (currentTime - updatedTime) / 60000;
                    const validAmountOfMinutesTillExpires = this.isGuestAddToCart ? 14400 : 15;

                    response = timeDiff < validAmountOfMinutesTillExpires ? true : false;

                } else {
                    response = false;
                }
            }
        }

        return response;
    }

    public _lsHasValidErumsData(objCart: any) {

        let response = false;

        if (this._lsValidErumsData(objCart)) {

           // TODO: We should clean this up after checking with cart team
           // Check if store is from ERUMS or not
           if (objCart['erumsStore']) {
               response = true;

           } else if (this._aemService.authorize() && this._aemService.checkAuthorizedCookie()) {
               response = true;
           }
        }

        return response;
    }

    /**
    * Method to update store for existing cart
    * calls v2 of cart API if disableCartV2 === false else calls v1 of cart API
    */

    public updateStoreForExistingCart = function(storeId, serviceType, deliveryType, offbanner, callback, zipcode?) {
      
        this.processStoreUpdateV2(storeId, serviceType, offbanner, callback, zipcode);

    };

    /**
     * Method to updated store id for existing cart using cart v2 API
     * @param storeId current user storeId
     * @param serviceType current user preference
     * @param offbanner pass true if user changing banner
     * @param callback callback function
     * @param zipcode user current zipcode
     */

    public processStoreUpdateV2(storeId, serviceType, offbanner, callback, zipcode) {
        const objCart = this._get(serviceType);
        if((this.isGuestAddToCart && objCart?.['guestCartId']) || !this.isGuestAddToCart) {
            const dataObs = this._cartV2Service.updateStoreForExistingCartV2(storeId, serviceType, zipcode, this.isGuestAddToCart);
            this.processObsResponse(dataObs, offbanner, callback);
        }else {
            if (typeof callback === 'function') {
                callback({
                    ack: true
                });
            }
        }
    }

    /**
     * Method which will take Observable as an input
     * If response is successful, then it will set abCart with whatever received and update cart price in the header.
     * If response is not successful, then it will set abCart with empty default values and update cart price in the header.
     */

    private processObsResponse(obs, offbanner?, callback?) {
        obs.subscribe((objResponse: any) => {
            if (objResponse && !offbanner) {
                this._set(objResponse);
                this._loadCartPrice();
            }
            if (typeof callback === 'function') {
                callback(objResponse);
            }
        }, (err: any) => {
            console.warn('========= CART API FAILED ========', err);

            // TODO: Do the analysis to move this into angular code
            // update cartId local storage
            this._aemService.invalidateCartId();
            // set empty cart obj
            this._set(this._cartV2Service.getV2EmptyCartsLSObj());
            this._loadCartPrice();
            if (typeof callback === 'function') {
                callback({
                    ack: true
                });
            }
        });
    }

    public refreshCart = function(objCart: any = {}, cartName: string = 'abs') {
        console.log('CART Refresh by: ', objCart);
        this.rightDrawerEvent.next({
            'event' : 'refreshCart',
            'data' : objCart
        })
        switch (true) {

            case objCart !== undefined && objCart.hasOwnProperty('cart'):
            case objCart !== undefined && Array.isArray(objCart['cartItems']):
                this._set(objCart);
                this.setAriaLiveCart('idAriaCartMsg', objCart, cartName);
                break;

            case !this._commonService.checkPendingOrder():
                console.log('REFRESH CART - REMOTE ERUMS CART');
                this._loadERUMSRemoteCart();
                break;

            default:
                console.log('REFRESH CART - REMOTE ECOM CART');
                this._loadRemoteCart();
                break;
        }
    };

    public mapErumsItems = function(items: any[]) {

        return items
            ? items.map((item: any) => ({
                id : item.itemId,
                name : item.name,
                quantity : item.qty,
                price : item.price,
                basePrice: item.basePrice,
                pricePerUnit: item.unitPrice,
                unitType: item.unitQuantity,
                totalPrice: item.totalPrice,
                clubCardSaving: item.clubCardSaving ? item.clubCardSaving : 0,
                isAvailable: item.isAvailable ? item.isAvailable : '',
                isFound: item.isFound ? item.isFound : '',
                savings: item.savings ? item.savings : [],
                clipped: item.clipped ? item.clipped : [],
                maxPurchaseQty: item.maxPurchaseQty,
                departmentName: item.departmentName
            }))
            : [];
    };

    public updateCartHeader = (cartCount, cartPrice, multiCartSummary?) => {
        // if it is enabled (disableCartv2 === false) and seller Cart if one or more
        let isNavigationEngineEnabled = false;
        if (window['SWY'] && window['SWY']['CONFIGSERVICE']?.featureToggleConfig) {
            isNavigationEngineEnabled =
                window['SWY'] && window['SWY']['CONFIGSERVICE']?.featureToggleConfig?.isNavigationEngineDisabled ? false : true;
        } else if (window['SWY'].configService?.isNavigationEngineDisabled && window['SWY'].configService?.isNavigationEngineDisabled === 'false') {
            isNavigationEngineEnabled = true;
        }

        if (multiCartSummary && Object.keys(multiCartSummary).length > 0) {
            if (multiCartSummary?.totalAvailableQuantity) {
                if (multiCartSummary?.totalAvailableQuantity <= 99) {
                    $('.badge-icon').removeClass('d-none badge-icon-plus');
                    $('.badge-text').removeClass('badge-text-plus').text(`${multiCartSummary?.totalAvailableQuantity}`);
                    if (isNavigationEngineEnabled) {
                        $('.badge-icon').removeClass('s_badge-icon-plus');
                        $('.badge-text').removeClass('s_badge-text-plus');
                    }
                } else if (multiCartSummary?.totalAvailableQuantity > 99) {
                    $('.badge-icon').removeClass('d-none').addClass('badge-icon-plus');
                    $('.badge-text').addClass('badge-text-plus').text('99+');
                    if (isNavigationEngineEnabled) {
                        $('.badge-icon').addClass('s_badge-icon-plus');
                        $('.badge-text').addClass('s_badge-text-plus');
                    }
                }
            }
            else {
                $('.badge-text').text('');
                $('.badge-icon').addClass('d-none');
            }
        } else {
            if (cartCount) {
                if (cartCount <= 99) {
                    $('.badge-icon').removeClass('d-none badge-icon-plus');
                    $('.badge-text').removeClass('badge-text-plus').text(`${cartCount}`);
                    if (isNavigationEngineEnabled) {
                        $('.badge-icon').removeClass('s_badge-icon-plus');
                        $('.badge-text').removeClass('s_badge-text-plus');
                    }
                } else if (cartCount > 99) {
                    $('.badge-icon').removeClass('d-none').addClass('badge-icon-plus');
                    $('.badge-text').addClass('badge-text-plus').text('99+');
                    if (isNavigationEngineEnabled) {
                        $('.badge-icon').addClass('s_badge-icon-plus');
                        $('.badge-text').addClass('s_badge-text-plus');
                    }
                }
            } else {
                $('.badge-text').text('');
                $('.badge-icon').addClass('d-none');
            }
        }
    }

    public _loadCartPrice = function() {

        let cartPrice = '0.00';
        let cartCount = 0;
        const objCart = this._get();

        if (objCart.cartPrice) {
            cartPrice = Intl.NumberFormat('en-US', {
                style: 'currency',
                currency: 'USD',
                minimumFractionDigits: 2,
                maximumFractionDigits: 2
            }).format(objCart.cartPrice);
        }

        if (objCart.cartQty) {
            cartCount = objCart.cartQty;
        }

        if (this._userInfoService.getPreference().toUpperCase() !== 'J4U') {
            $('.ab-cart a').attr('aria-label', `Shopping Cart, ${cartCount} items, Total ${cartPrice}`);
            this.updateCartHeader(cartCount, cartPrice, objCart['multiCartSummary']);
        }

    };

    public setAriaLiveCart(idAriaMsg: string, objCart: any, cartName: string) {

        const elem = $(`#${idAriaMsg}`);

        if (!this._commonService.isEmpty(objCart?.cart) && cartName in objCart.cart) {
            if (
                objCart.cart?.[cartName]?.summary && objCart.cart?.[cartName].summary.itemCount && 
                objCart.cart?.[cartName].summary.finalTransactionTotal &&
                objCart.cart?.[cartName].summary.totalItemQuantity
            )
            {
                let strCartMessage = '';
                const carts = ['1P_WINE']; 
                if(carts.includes(cartName)) {
                    strCartMessage = `${objCart.cart?.[cartName].summary.itemCount} products added to your cart from ${this._cartV2Service.getCartFullName(cartName)}. ${objCart.cart?.[cartName].summary.totalItemQuantity} total items in your cart. Estimated total $${objCart.cart?.[cartName].summary.finalTransactionTotal}.`
                } else {
                    strCartMessage = `${objCart.cart?.[cartName].summary.itemCount} products added to your cart from ${this._aemService.getBanner()} banner. ${objCart.cart?.[cartName].summary.totalItemQuantity} total items in your cart. Estimated total $${objCart.cart?.[cartName].summary.finalTransactionTotal}.`
                }
                elem.html(strCartMessage);
            }
        }

        // clear cart message after 3 seconds
        setTimeout(() => {
            elem.html('');
        }, 3000);

    }

    public processOfferComplete(objCart: any, couponList: any[], product: any) {

        const isWYSIWYGEnabled = objCart && objCart['isWYSIWYGEnabled'] ? objCart['isWYSIWYGEnabled'] : false;

        if (isWYSIWYGEnabled && objCart['cartItems']) {

            const cartItemsList = objCart['cartItems'];
            let cartProduct: any;

            if (product.id) {
                cartProduct = cartItemsList.find((item: any) => item.itemId.toString() === product.id.toString());
            } else if (product.itemId) {
                cartProduct = cartItemsList.find((item: any) => item.itemId.toString() === product.itemId.toString());
            }

            if (cartProduct && cartProduct.savings && cartProduct.savings.length > 0) {

                couponList.forEach((coupon: any) => {

                    const couponOfferComplete = cartProduct.savings.find((savingCoupon: any) =>
                        savingCoupon.omsOfferId === coupon.offerId
                    );

                    coupon['offerComplete'] = couponOfferComplete && couponOfferComplete.display ? true : false;
                });

            } else {
                couponList.forEach((coupon: any) => coupon['offerComplete'] = false);
            }

        } else {
            couponList.forEach((coupon: any) => coupon['offerComplete'] = false);
        }
        return couponList;
    }

    public processBOGOComplete(objCart: any, product: any) {

        const isWYSIWYGEnabled = objCart && objCart['isWYSIWYGEnabled'] ? objCart['isWYSIWYGEnabled'] : false;

        if (isWYSIWYGEnabled) {

            if (objCart && objCart['cartItems']) {

                const cartItemsList = objCart['cartItems'];

                let cartProduct: any;

                if (
                    (product.promoType === 'M' || product.promoType === 'B')
                    && this._commonService.isProductPromoActive(product)
                ) {

                    if (product.id) {
                        cartProduct = cartItemsList.find((item: any) => item.itemId.toString() === product.id.toString());
                    } else if (product.itemId) {
                        cartProduct = cartItemsList.find((item: any) => item.itemId.toString() === product.itemId.toString());
                    }
                }

                if (cartProduct) {

                    const couponBOGO = cartProduct.savings && cartProduct.savings.length > 0
                        ? cartProduct.savings.find((savingCoupon: any) => savingCoupon.source === 'CMS' && savingCoupon.linkPluNumber)
                        : {};

                    product['offerComplete'] = couponBOGO && couponBOGO.display ? true : false;

                } else {
                    product['offerComplete'] = false;
                }
            }

        } else {
            product['offerComplete'] = false;
        }
    }

    /**
     * Method generating the image url.
     *
     * @param product current product info
     * @param viewport user browser window size
     */
    public getImageUrl(product: any, viewport: string) {

        let imageUrl = '';

        if (
            this._commonService.checkPendingOrder()
            && this._aemService.getDMTMiniCart()
            && product
            && product.id
        ) {
            imageUrl = this._aemService.getDMTMiniCart().replace('${product.id}', product.id);
            imageUrl = imageUrl.replace('${viewport}', viewport);

        } else if (
            this._aemService.getDMTMiniCart()
            && product
            && product.itemId
        ) {
            imageUrl = this._aemService.getDMTMiniCart().replace('${product.id}', product.itemId);
            imageUrl = imageUrl.replace('${viewport}', viewport);
        }

        return imageUrl;
    }

    public loadPendingOrderData() {
        this._commonService._cartObjSource.next(this._get());
        this._loadCartPrice();
    }

   

   

}
